export const AVATAR_COLORS = [
  '#f56a00',
  '#7265e6',
  '#ffbf00',
  '#00a2ae',
  '#87d068',
  '#ff7875',
  '#1890ff',
  '#722ed1',
  '#13c2c2',
  '#eb2f96',
  '#52c41a',
  '#fa8c16',
  '#2f54eb',
  '#a0d911',
  '#fa541c',
  '#f5222d',
  '#faad14',
  '#8c7ae6',
  '#2ed573',
  '#ff6b6b',
  '#4ecdc4',
  '#45b7d1',
  '#96ceb4',
  '#feca57',
  '#ff9ff3',
  '#54a0ff',
  '#5f27cd',
  '#00d2d3',
  '#ff9f43',
  '#10ac84',
  '#ee5a24',
  '#0984e3',
  '#6c5ce7',
  '#a29bfe',
  '#fd79a8',
  '#fdcb6e',
  '#e17055',
  '#00b894',
  '#e84393',
  '#00cec9',
  '#74b9ff',
  '#0984e3',
  '#6c5ce7',
  '#a29bfe',
  '#fd79a8',
  '#fdcb6e',
  '#e17055',
  '#00b894',
];

export const getAvatarColor = (name: string): string => {
  if (!name || name.length === 0) return AVATAR_COLORS[0];

  // Lấy mã ASCII của chữ cái đầu
  const firstCharCode = name.charCodeAt(0);

  // Lấy độ dài tên
  const nameLength = name.length;

  // Kết hợp chữ cái đầu và độ dài để tạo index
  const index = (firstCharCode + nameLength * 7) % AVATAR_COLORS.length;

  return AVATAR_COLORS[index];
};
